module.exports = __webpack_public_path__ + "img/ico-ready-to-move-in-done.0cfa1da8.svg";